import React, {useRef} from "react";
// import { debug } from "../../utils";
// import { connect } from "react-redux";
// import { uploadWinrmHttpsCertificate } from "../deviceService";
// import { showSuccessToast, showDangerToast } from "../../validation/ToastContainer";


function WinrmHttpsField({ value, onChange, onfileChange, disabled }) {

    
    const fileInputRef = useRef(null);
    const uploadCertificate = (event) => {
        fileInputRef.current.click();
    }

    // const onfileChange = (event) => {
    //     const file = event.target.files[0];
    //     if (file) {
    //         uploadWinrmHttpsCertificate(file)
    //         .then(filePath => {
    //             if (filePath) {
    //                 showSuccessToast("Certificate Uploaded", "Https Certificate");
    //                 modalDataService.changeHttpsCertificatePath(filePath);                    
    //             } else {
    //                 showDangerToast("Upload failed: no file path returned", "Error");
    //             }
    //         })
    //         .catch(err => {
    //             // Catches the thrown error from !response.ok
    //             showDangerToast(err.message, "Error");
    //         });
    //     }
    //     event.target.value = null; // reset input so onChange fires again next time
    // };

    //const onChange = (value) => modalDataService.changeWinrmHttps(value);

    return (
        <div className="form-group">
            <div className="oct_check oct_check-v2 oct_check-v2-remediation modal-v2-remediation-toggle">
                <label className="oct_check-label oct_check-label-v2 oct_check-label-v2-remediation modal-v2-remediation-label">
                    <input type="checkbox" 
                            checked={!!value} 
                            disabled={disabled}
                            onChange={disabled ? null : () => onChange(!value)} />
                    <span className="oct_check-copy-v2 oct_check-copy-v2-remediation modal-v2-remediation-copy">
                        <span className="oct_check-title-v2 modal-v2-remediation-title">HTTPS</span>
                        {/* <span className="oct_check-help-v2 modal-v2-remediation-help">Automatically apply security fixes and compliance updates when violations are detected</span> */}
                    </span>
                </label>
                
                {value &&
                    <div className="col-6">                        
                        <button 
                            type="button"
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                uploadCertificate();
                            }} 
                            className="oct_settings-btn-v2"
                        >
                            Upload Certificate
                        </button>
                        <input
                            id="file-upload"
                            type="file"
                            ref={fileInputRef}
                            onChange={onfileChange}
                            accept=".pem, .crt, .cer, .pfx, .p12"
                            className="d-none"
                        />
                    </div>
                }
            </div>
        </div>
    )

}

// function mapStateToProps(state) {
//     debug("WinrmHttpsField mapStateToProps", state);
//     const editDeviceModal = state.editDeviceModal;
//     return {
//         winrmhttps: editDeviceModal.winrmhttps || false,
//         httpsCertFilePath: editDeviceModal.httpsCertFilePath || ''
//     }
// }

// export default connect(mapStateToProps)(WinrmHttpsField);

export default WinrmHttpsField;